import React from 'react'

import PropTypes from 'prop-types'
import {Redirect} from 'react-router-dom'
import {useSelector} from 'react-redux'

import {makeStyles} from '@material-ui/core/styles'
import {AppBar, Container, Tab, Tabs} from '@material-ui/core'
import Box from "@material-ui/core/Box";

import Page from 'components/Page/Page'

import RecyclableStats from './RecyclableStats.js'
import CustomerStats from './CustomerStats.js'
import Cashdrawers from './Cashdrawers.js'
import Inventory from './Inventory.js'
import EcocontrolScans from "./EcocontrolScans";

const useStyles = makeStyles((theme) => ({}))

const EmployeePage = ({children}) => {
  const auth = useSelector(state => state.auth)
  const classes = useStyles()

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
      <div {...other}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  if (!auth.access_token) {
    return <Redirect to="/login"/>
  }

  function hasPermission(perm) {
    for (var i = 0; i < auth.permissions.length; i++) {
      if (auth.permissions[i][0] == perm[0] && auth.permissions[i][1] == perm[1]) {
        return true
      }
    }
    return false
  }

  return (
    <Page title="Employees">
      <Container maxWidth={false}>

        <AppBar position="static">
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" variant="scrollable">
            <Tab label="Recyclables"/>
            <Tab label="Inventory"/>
            <Tab label="Cashdrawers"/>
            <Tab label="Customer Signups"/>
            <Tab label="Ecocontrol Scans"/>
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0}>
          {(hasPermission(["Admin", "admin"]) || hasPermission(["Normal", "user"])) &&
            <RecyclableStats/>
          }
        </TabPanel>

        <TabPanel value={value} index={1}>
          {(hasPermission(["Admin", "admin"]) || hasPermission(["Normal", "user"])) &&
            <Inventory/>
          }
        </TabPanel>

        <TabPanel value={value} index={2}>
          {(hasPermission(["Admin", "admin"]) || hasPermission(["Normal", "user"])) &&
            <Cashdrawers/>
          }
        </TabPanel>

        <TabPanel value={value} index={3}>
          {(hasPermission(["Admin", "admin"]) || hasPermission(["Normal", "user"])) &&
            <CustomerStats/>
          }
        </TabPanel>

        <TabPanel value={value} index={4}>
          {(hasPermission(["Admin", "admin"]) || hasPermission(["Normal", "user"])) &&
            <EcocontrolScans/>
          }
        </TabPanel>

      </Container>
    </Page>
  )
}

export default EmployeePage

EmployeePage.propTypes = {
  children: PropTypes.node
}
